// Import utilities
import {
	isEmpty
} from '@automator/utilities';

/**
 * Creates a Snackbar with the specified message and options.
 *
 * @param {Object} options - The options for the Snackbar.
 * @param {String} options.message - The message to display in the Snackbar.
 * @param {Node} [options.$parentElement=document.body] - The parent element to append the Snackbar to.
 * @param {Boolean} [options.isFixed=true] - Whether the Snackbar should be fixed or not.
 * @param {String} [options.position='bottom-center'] - The position of the Snackbar.
 * @param {Number} [options.duration=-1] - The duration of the Snackbar in milliseconds. Use -1 for infinite duration.
 * @param {String} [options.iconId] - The ID of the icon to display in the Snackbar.
 * @param {String} [options.iconAnimation] - The animation to apply to the icon.
 * @return {Node} - The Snackbar element.
 */
const createSnackbar = ( {
	message,

	$parentElement = document.body,
	isFixed = true,
	position = 'bottom-center',
	duration = -1,

	iconId,
	iconAnimation
} ) => {
	// Check if there is a message defined
	if ( isEmpty( message ) ) {
		return;
	}

	// Check if the wrapper that will contain the Snackbar exists
	if ( ! document.body && ! document.body.contains( $parentElement ) ) {
		return;
	}

	// Create the Snackbar
	const $snackbar = document.createElement( 'uo-snackbar' );
	// Message
	$snackbar.message = message;
	// Fixed status
	$snackbar.isFixed = isFixed;
	// Position
	$snackbar.position = position;
	// Duration
	$snackbar.duration = duration;

	// Check if we have to create an icon
	if ( ! isEmpty ( iconId ) ) {
		$snackbar.insertAdjacentHTML( 'beforeEnd', `
            <uo-icon
                slot="icon"
                id="${ iconId }"
                ${ ! isEmpty( iconAnimation ) ? `animation="${ iconAnimation }"` : '' }
            ></uo-icon>
        ` );
	}

	// Show Snackbar
	$parentElement.appendChild( $snackbar );

	return $snackbar;
}

export default createSnackbar;
